export default __webpack_public_path__ + "static/media/ly.f93c267c.svg";